import { getStoreBuilder, BareActionContext } from 'vuex-typex';
import { RootState } from './index';
import { Cart, AddOrUpdateCartItem, OrderRow, ProductPriceStockRequest } from '@/models/Cart/Cart';
import { ApiService } from '@/services/ApiService';

export interface CheckoutState {
    cart: Cart;
}

const initialState: CheckoutState = {
    cart: {} as Cart
};

const store = getStoreBuilder<RootState>().module('checkout', initialState);

// private getters
function getStoreCart(state: CheckoutState): Cart {
   // console.log('cart', state.cart);
    return state.cart;
}

// getters
const getStateCart = store.read(getStoreCart, 'getStoreCart');

// mutations:

function mutateUpdateRows(state: CheckoutState): void {
    state.cart.orderRows.forEach(row => {
        const payload: ProductPriceStockRequest = {
            quantity: row.quantity,
            variantId: row.articleNumber,
            checkLitiumInventory: false
        };
    });
}

function mutateSaveState(state: CheckoutState, payload: CheckoutState): Promise<void> {
    return new Promise((resolve, reject) => {
        state.cart = payload.cart;
        mutateUpdateRows(state);
        resolve();
    });
}

function mutateAddCart(state: CheckoutState, payload: AddOrUpdateCartItem): Promise<void> {
    return new Promise((resolve, reject) => {
        ApiService.addToCart(payload).then(response => {
            if (response && response.data) {
                state.cart = response.data;
                mutateUpdateRows(state);
            }
            resolve();
        });
    });
}
function mutateAddListCart(state: CheckoutState, payload: Array<AddOrUpdateCartItem>): Promise<void> {
    return new Promise((resolve, reject) => {
        ApiService.addListToCart(payload).then(response => {
            if (response && response.data) {
                state.cart = response.data;
                mutateUpdateRows(state);
            }
            resolve();
        });
    });
}

function mutateUpdateCart(state: CheckoutState, payload: AddOrUpdateCartItem): Promise<void> {
    return new Promise((resolve, reject) => {
        if (
            !state.cart.orderRows ||
            state.cart.orderRows.findIndex(row => row.articleNumber === payload.articleNumber) === -1
        ) {
            ApiService.addToCart(payload).then(response => {
                if (response && response.data) {
                    state.cart = response.data;
                    mutateUpdateRows(state);
                }
                resolve();
            });
        } else {
            ApiService.updateCart(payload).then(response => {
                if (response && response.data) {
                    state.cart = response.data;
                    mutateUpdateRows(state);
                }
                resolve();
            });
        }
    });
}

function mutateReloadCart(state: CheckoutState): Promise<void> {
    return new Promise((resolve, reject) => {
        ApiService.getMiniCart().then(response => {
            if (response && response.data) {
                state.cart = response.data;
                mutateUpdateRows(state);
            }
            resolve();
        });
    });
}

function mutateImportToCart(state: CheckoutState, payload: File): Promise<void> {
    return new Promise((resolve, reject) => {
        ApiService.importExcelToCheckout(payload).then(response => {
            if (response && response.data) {
                state.cart = response.data;
                if (state.cart.orderRows != null) {
                    mutateUpdateRows(state);
                }
            }
            resolve();
        });
    });
}

// actions
async function saveState(context: BareActionContext<CheckoutState, RootState>, payload: CheckoutState): Promise<void> {
    return await mutateSaveState(context.state, payload);
}

async function addState(
    context: BareActionContext<CheckoutState, RootState>,
    payload: AddOrUpdateCartItem
): Promise<void> {
    return await mutateAddCart(context.state, payload);
}

async function addListState(
    context: BareActionContext<CheckoutState, RootState>,
    payload: Array<AddOrUpdateCartItem>
): Promise<void> {
    return await mutateAddListCart(context.state, payload);
}

async function updateState(
    context: BareActionContext<CheckoutState, RootState>,
    payload: AddOrUpdateCartItem
): Promise<void> {
    return await mutateUpdateCart(context.state, payload);
}

async function reloadState(context: BareActionContext<CheckoutState, RootState>): Promise<void> {
    return await mutateReloadCart(context.state);
}
async function excelImportState(context: BareActionContext<CheckoutState, RootState>, payload: File): Promise<void> {
    return await mutateImportToCart(context.state, payload);
}

// export store
export const CheckoutStore = {
    get cart() {
        return getStateCart();
    },
    saveState: store.dispatch(saveState, 'saveState'),
    addState: store.dispatch(addState, 'addState'),
    addListState: store.dispatch(addListState, 'addListState'),
    updateState: store.dispatch(updateState, 'updateState'),
    reloadState: store.dispatch(reloadState, 'reloadState'),
    excelImportState: store.dispatch(excelImportState, 'excelImportState')
};
